import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Col,
  Row
} from "react-bootstrap";


import Guest from "../../../layouts/Guest";
import RegistrationWizard from "../../Forms/Private/VegeFestEventRegistrationWizard/RegistrationWizard";


function VegeFestEventRegisterPage() {

  return (
    <>
      <Guest>
        <RegistrationWizard />
      </Guest>
    </>
  );
}

export default VegeFestEventRegisterPage;
